import { defineStore } from 'pinia'
import { GetLoginUser } from "@/api/login";
import { logOut } from '@/api/login' 
import { removeToken } from '@/utils/auth'
import { loginOutFuc } from '@/utils/loginOut'
import { UserDetail } from "@/api/system/user";

// useStore 可以是 useUser、useCart 之类的任何东西
// 第一个参数是应用程序中 store 的唯一 id
export const useUserStore = defineStore('main', {
  state: () => ({
    userInfo: {},
    userDetailInfo: {},
  }),
  actions: {
    async setUserInfo(callback) {
      try {
        this.userInfo = await GetLoginUser();
        callback && callback()
      } catch (error) {
        console.log("err", error);
      }
    },
    async setUserDetailInfo() {
      try {
        this.userDetailInfo = await UserDetail(this.userInfo.user_id);
      } catch (error) {
        console.log("err", error);
      }
    },
    async loginOut(router) {
      try {
        await logOut();
        loginOutFuc()
        removeToken()
        router.push('/login')
      } catch (error) {
        console.log("err", error);
      }
    }
  },
  getters: {
    getterUserInfo () {
      return this.userInfo;
    },
    getterUserDetailInfo () {
      return this.userDetailInfo;
    }
  }
})